import React from 'react';
import ds from 'designsystem';
import styled from 'styled-components';

const OkIcon = styled.svg`
    width: ${ds.get('metrics.s')};
    height: ${ds.get('metrics.s')};
    position: absolute;
    bottom: 0;
    right: 0;
    transform: scaleX(1.1) translateY(-50%);
    stroke: ${ds.brand('product')};
    scaleX: 1.5;
    fill: none;
    z-index: 10;
`;

const CustomOkIcon = () => (
  <OkIcon viewBox="0 0 20 20">
    <polyline points="1,12 7,18 18,5" />
  </OkIcon>
);

export default CustomOkIcon;



// WEBPACK FOOTER //
// ./src/blocks/Form/OkIcon.jsx